export default __webpack_public_path__ + "public/img/laptop-icon.svg";